module.exports = __webpack_public_path__ + "static/media/facebook-f.694c4aa2.svg";